import {
  Avatar,
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import appcolors from "../../../constants/Colors";
import { useSelector } from "react-redux";

const tableStyle = {
  "&.MuiTableContainer-root": {
    border: "1px solid grey",
    borderRadius: 1,
    overFlow: "hidden",
  },
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "1rem",
    },
};

const RejectedDetail = ({ rejections }) => {
    const { currentLanguage } = useSelector((state) => state.languageReducer);
  
  return (
    <TableContainer sx={tableStyle}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t("rejectedAt")}</TableCell>
            <TableCell>{t("worker")}</TableCell>
            <TableCell>{t("company")}</TableCell>
            <TableCell>{t("reason")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rejections?.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell>
                  {moment(item?.createdAt).format("MM/DD/YYYY [at] hh:mm:a")}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                    <Avatar
                      src={item?.workerId?.profileImg}
                      sx={{
                        height: 60,
                        width: 60,
                        borderRadius: 2,
                        border: "1px solid grey",
                      }}
                    />
                    <Box>
                      <Typography textTransform={"capitalize"}>
                        {item?.workerId?.name}
                      </Typography>
                      <Typography variant="body2">
                        {item?.workerId?.email}/{item?.workerId?.contact}
                      </Typography>
                    </Box>
                  </Stack>
                </TableCell>
                <TableCell component="th" scope="row">
                  <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                    <Avatar
                      src={item?.companyId?.profileImg}
                      sx={{
                        height: 60,
                        width: 60,
                        borderRadius: 2,
                        border: "1px solid grey",
                      }}
                    />
                    <Box>
                      <Typography textTransform={"capitalize"}>
                        {item?.companyId?.name}
                      </Typography>
                      <Typography variant="body2">
                        {item?.companyId?.email}/{item?.workerId?.contact}
                      </Typography>
                    </Box>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Typography>{item.reason}</Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RejectedDetail;
